<template>
  <div class="new-conversation">
    <AppLayout centered title="New Message" parent="/conversations" isDetails>
      <template v-slot:body>
        <div class="container col-md-8 col-sm-12" v-if="sections.length">
          <v-tabs centered v-model="selectedTab" class="basic-tabs">
            <v-tab v-for="sectionName in sections" :key="sectionName">
              {{ sectionName | capitalize }}
            </v-tab>
          </v-tabs>
          <ConversationMessage
            :format="sections[selectedTab]"
            :selectedCandidatesIds="selectedCandidatesIds"
            :selectedBookingId="selectedBookingId"
            :selectedOfferId="selectedOfferId"
          />
        </div>
      </template>
    </AppLayout>
  </div>
</template>

<script>
import AppLayout from "@/components/common/base-layouts/AppLayout";
import ConversationMessage from "@/views/conversations/components/ConversationMessage";
import { isPermissioned } from "@/utils/permissions";

export default {
  name: "NewConversation",
  components: {
    AppLayout,
    ConversationMessage
  },
  data() {
    return {
      selectedTab: 0,
      selectedBookingId: "",
      selectedOfferId: "",
      selectedCandidatesIds: []
    };
  },
  computed: {
    sections() {
      return [
        isPermissioned("conversations.create.email") && "email",
        isPermissioned("conversations.create.sms") && "text"
      ].filter(Boolean);
    }
  },
  created() {
    const {
      selectedCandidatesIds,
      selectedBookingId,
      selectedOfferId
    } = this.$route.params;
    this.selectedCandidatesIds = selectedCandidatesIds;
    this.selectedBookingId = selectedBookingId;
    this.selectedOfferId = selectedOfferId;
  }
};
</script>

<style lang="scss"></style>
